import Arrow from "shared/components/utils/icons/Arrow";
import PropTypes from "prop-types";

const CopyNextHoursButtonLayer = ({
    onClick,
    color,
    ...props
}) => {

    const handleClick = (e) => {
        e.stopPropagation();
        onClick(e);
    };

    return (
        <div {...props}>
            <button
                type="button"
                onClick={handleClick}
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex" }}
            >
                <Arrow size={"12"} direction="right" hover style={{stroke: {color}}} />
            </button>
        </div>
    );
};

CopyNextHoursButtonLayer.propTypes = {
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string,
};

export default CopyNextHoursButtonLayer;
